const moduleKey = 'DEPOSIT_TUTORIALS';

export const depositTutorialsyTypes = {
  LOAD_REQUESTED: moduleKey + "_LOAD_REQUESTED",
  LOADED: moduleKey + "_LOADED",
  SET_TABLE_CONFIG: moduleKey + "_SET_TABLE_CONFIG",
  SET_TABLE_CONFIG_FILTER: moduleKey + "_SET_TABLE_CONFIG_FILTER",
  CHANGE_TAB: moduleKey + '_CHANGE_TAB',
  CLOSE_TAB: moduleKey + '_CLOSE_TAB',
  CREATE_TAB: moduleKey + '_CREATE_TAB',
  GET_DETAIL_REQUESTED: moduleKey + '_GET_DETAIL_REQUESTED',
  GET_DETAIL_LOADED: moduleKey + '_GET_DETAIL_LOADED',
  UPDATE_SUCCESS: moduleKey + '_UPDATE_SUCCESS'
};

export const depositTutorialsActions = {
  loadRequested: (tableConfig) => ({ type: depositTutorialsyTypes.LOAD_REQUESTED, tableConfig }),
  loaded: (data) => ({ type: depositTutorialsyTypes.LOADED, payload: { data } }),
  setTableConfig: (key, value) => ({ type: depositTutorialsyTypes.SET_TABLE_CONFIG, key, value }),
  setTableConfigFilter: (key, value) => ({ type: depositTutorialsyTypes.SET_TABLE_CONFIG_FILTER, key, value }),
  changeTab: (key) => ({ type: depositTutorialsyTypes.CHANGE_TAB, key }),
  closeTab: (key) => ({ type: depositTutorialsyTypes.CLOSE_TAB, key }),
  createTab: (key, title) => ({ type: depositTutorialsyTypes.CREATE_TAB, key, title }),
  getDetail: (id, index) => ({ type: depositTutorialsyTypes.GET_DETAIL_REQUESTED, id, index }),
  getDetailLoaded: (data, index) => ({ type: depositTutorialsyTypes.GET_DETAIL_LOADED, payload: { data }, index }),
  updateSuccess: (index) => ({ type: depositTutorialsyTypes.UPDATE_SUCCESS, index })
};
